export default __webpack_public_path__ + "static/media/Agent.b6757161.svg";